var anglicize = require("./lib/anglicize");

module.exports = anglicize;
